import React from 'react';
import PropTypes from 'prop-types';
import useScrollIntoView from '../hooks/useScrollIntoView';
import { joinClassNames } from '../utils';

ExpandedListTab.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    scrollToTop: PropTypes.bool,
};

function ExpandedListTab(props) {
    const {
        className = null,
        title = null,
        children,
        scrollToTop = false,
    } = props;
    const formRef = useScrollIntoView(scrollToTop);
    return (
        <form
            ref={formRef}
            className={joinClassNames(className, 'rich-list-row-expanded')}
            onSubmit={(event) => event.preventDefault()}
        >
            {title && <h4>{title}</h4>}
            {children}
        </form>
    );
}

export default ExpandedListTab;
